import { render, staticRenderFns } from "./LeadWizard.vue?vue&type=template&id=3ec50e57"
import script from "./LeadWizard.vue?vue&type=script&lang=js"
export * from "./LeadWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports